import React                          from "react";

import Alert                          from 'react-bootstrap/Alert';
import { FontAwesomeIcon }            from '@fortawesome/react-fontawesome';
import { faExclamationTriangle }      from '@fortawesome/free-solid-svg-icons';

const BomErrors = (props) => {

  const { 
    bom_line_items, 
    selected_board_qty 
  } = props;
  
  const bom_errors = bom_line_items.map((bli) => bli.error_message[selected_board_qty]).filter((error_message) => error_message && error_message != "")
  if(bom_errors.length == 0) return null

  return (
    <Alert variant="light" className="border text-end mt-3 text-danger">
      <FontAwesomeIcon icon={faExclamationTriangle}/> {bom_errors.length} parts have issues that need to be resolved.
    </Alert>
  )
}

export default BomErrors;